<template>
  <app-page-container :showNav="true" :clean="true" :background="'calendar'">
    <div>{{ hello }}</div>
  </app-page-container>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer";
import { mapState } from "vuex";

export default {
  name: "Dashboard",
  components: {
    AppPageContainer,
  },
  data() {
    return {
      hello: ":)",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
};
</script>

<style scoped></style>
